import { render, staticRenderFns } from "./UserRiskDialog.vue?vue&type=template&id=a51507a0&scoped=true&"
import script from "./UserRiskDialog.vue?vue&type=script&lang=js&"
export * from "./UserRiskDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserRiskDialog.vue?vue&type=style&index=0&id=a51507a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51507a0",
  null
  
)

export default component.exports